import { Stack } from "@mui/material";
import { PlaybookTitle } from "./PlaybookTitle";
import { UlList } from "./UlList";
import { H4Component } from "./H4Component";
import { NoticeList } from "./NoticeList";
import { AmnesiaBestPracticesType } from "../../../../types";
import { useEffect } from "react";

export const LeadAmnesiaBestPracticesBlock = ({
  summary_points,
  example,
  setTopic,
}: AmnesiaBestPracticesType & { setTopic: (topic: string) => void }) => {
  const topic = "Prospect Amnesia Best Practices";

  useEffect(() => {
    setTopic(topic);
  }, [topic]);

  return (
    <Stack gap={"20px"} id={topic}>
      <PlaybookTitle text={topic} />
      <UlList text={[]} items={summary_points} />
      <Stack gap={"8px"}>
        <H4Component text={"Example:"} />
        <NoticeList text={[example]} />
      </Stack>
    </Stack>
  );
};
